import { render, staticRenderFns } from "./InfoHint.vue?vue&type=template&id=397c9d05"
import script from "./InfoHint.vue?vue&type=script&lang=js"
export * from "./InfoHint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports